/**
 * Listeners
 */
export const I13N_TYPE_CLICK = 'click';
export const I13N_TYPE_EXCEPTION = 'exception';
export const I13N_TYPE_FEATURE_COUNT = 'count';
export const I13N_TYPE_LOG = 'log';
export const I13N_TYPE_PAGE_VIEW = 'pageview';
export const I13N_TYPE_SET_VALUE = 'setValue';
export const I13N_TYPE_SUBSCRIBE = 'subscribe';
export const I13N_TYPE_TIMING = 'timing';
export const I13N_TYPE_VIEW = 'view';
export const I13N_TYPE_CLEAN_UP = 'cleanup';

// Enhanced e-commerce
// https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce
export const I13N_TYPE_ENHANCED_ECOMMERCE = 'ecommerce';

export const I13N_ACTION_EC_ADD_TO_CART = 'add_to_cart';
export const I13N_ACTION_EC_CHECKOUT_OPTION = 'set_checkout_option';
export const I13N_ACTION_EC_CHECKOUT_PROCESS = 'checkout_progress';
export const I13N_ACTION_EC_CHECKOUT_START = 'begin_checkout';
export const I13N_ACTION_EC_CLICK_PROMOTION = 'select_content';
export const I13N_ACTION_EC_LIST_IMPRESSION = 'view_item_list';
export const I13N_ACTION_EC_PRODUCT_CLICK = 'select_content';
export const I13N_ACTION_EC_PRODUCT_IMPRESSION = 'view_item';
export const I13N_ACTION_EC_PRODUCTS_IMPRESSION = 'view_item_list';
export const I13N_ACTION_EC_PURCHASE = 'purchase';
export const I13N_ACTION_EC_REMOVE_PRODUCT = 'remove_from_cart';
export const I13N_ACTION_EC_VIEW_PROMOTION = 'view_promotion';
export const I13N_ACTION_EC_VAULT_START = 'begin_vault';
export const I13N_ACTION_EC_VAULT_SUCCESS = 'success_vault';

// https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#product-data
export type I13nProductData = {
  id?: string;
  name: string;
  brand?: string;
  category?: string;
  variant?: string;
  price?: number;
  quantity?: number;
  coupon?: string;
  list_position?: number;
};

/**
 * Category
 */
export const I13N_CATEGORY_API = 'API';
export const I13N_CATEGORY_APP = 'App';
export const I13N_CATEGORY_CONSUMABLES = 'Consumables';
export const I13N_CATEGORY_LOGIN = 'Login';
export const I13N_CATEGORY_MATCHES = 'Matches';
export const I13N_CATEGORY_ONBOARDING = 'Onboarding';
export const I13N_CATEGORY_PAYMENT = 'Payment';
export const I13N_CATEGORY_POST_MATCH = 'Post Match';
export const I13N_CATEGORY_PREMIUM_GOLD = 'Tinder Gold';
export const I13N_CATEGORY_PREMIUM_PLUS = 'Tinder Plus';
export const I13N_CATEGORY_PROFILE = 'Profile';
export const I13N_CATEGORY_RECS = 'Recs';
export const I13N_CATEGORY_SAGA = 'Saga';
export const I13N_CATEGORY_SETTINGS = 'Settings';
export const I13N_CATEGORY_SUBSCRIPTION = 'Subscription';
export const I13N_CATEGORY_UI = 'UI';
export const I13N_CATEGORY_VERIFICATION = 'Verification';

export type I13nCategory =
  | typeof I13N_CATEGORY_API
  | typeof I13N_CATEGORY_APP
  | typeof I13N_CATEGORY_CONSUMABLES
  | typeof I13N_CATEGORY_LOGIN
  | typeof I13N_CATEGORY_MATCHES
  | typeof I13N_CATEGORY_ONBOARDING
  | typeof I13N_CATEGORY_PAYMENT
  | typeof I13N_CATEGORY_POST_MATCH
  | typeof I13N_CATEGORY_PREMIUM_GOLD
  | typeof I13N_CATEGORY_PREMIUM_PLUS
  | typeof I13N_CATEGORY_PROFILE
  | typeof I13N_CATEGORY_RECS
  | typeof I13N_CATEGORY_SAGA
  | typeof I13N_CATEGORY_SETTINGS
  | typeof I13N_CATEGORY_SUBSCRIPTION
  | typeof I13N_CATEGORY_UI
  | typeof I13N_CATEGORY_VERIFICATION;

/**
 * Actions
 */
export const I13N_ACTION_ADD = 'Add';
export const I13N_ACTION_AUTHORIZE = 'Authorize';
export const I13N_ACTION_CANCEL = 'Cancel';
export const I13N_ACTION_CHANGE_VALUE = 'Change value';
export const I13N_ACTION_CLICK = 'Click';
export const I13N_ACTION_COMPLETE = 'Complete';
export const I13N_ACTION_COMPLETE_LOGIN = 'CompleteLogin';
export const I13N_ACTION_COMPLETE_REGISTRATION = 'CompleteRegistration';
export const I13N_ACTION_CONTINUE = 'Continue';
export const I13N_ACTION_DELETE = 'Delete';
export const I13N_ACTION_DOB_DEVICE_FLAGGED = 'Device Flagged - DOB';
export const I13N_ACTION_DOB_DEVICE_UNFLAGGED = 'Device Unflagged - DOB';
export const I13N_ACTION_FETCH = 'Fetch data';
export const I13N_ACTION_LOGIN = 'Login';
export const I13N_ACTION_NAVIGATE = 'Navigate';
export const I13N_ACTION_PAUSE = 'Pause';
export const I13N_ACTION_PROGRESS = 'Progress';
export const I13N_ACTION_PURCHASE = 'Purchase';
export const I13N_ACTION_REARRANGE = 'Rearrange';
export const I13N_ACTION_SEND = 'Send';
export const I13N_ACTION_SEND_ERROR = 'Send error';
export const I13N_ACTION_START = 'Start';
export const I13N_ACTION_SWIPE = 'Swipe';
export const I13N_ACTION_VERIFY = 'Verify';
export const I13N_ACTION_VIEW = 'View';
